import React, { memo } from "react";
import { Breadcrumb } from "antd";
import styled from "styled-components";
import { setUrlFormat } from "@Lib/common";
import { host } from "@Services/url";

const { www } = host;

interface ICrumbItem {
  label: string;
  url?: string;
}

interface IProps {
  items: ICrumbItem[];
  sticky?: boolean;
  stickyLeft?: number;
}

const BreadcrumbStyled = styled(Breadcrumb)`
  .ant-breadcrumb-separator {
    color: #939baf;
    margin: 0 3px;
  }
`;

const Crumbs: React.FC<IProps> = ({ items, sticky = false, stickyLeft }) => {
  return (
    <section
      id="tracking-CommonCrumbs"
      className={`w-[800px] text-[#939BAF] pb-14 text-14 flex items-center pt-6 ${sticky ? `sticky` : ""}`}
      style={{
        left: sticky ? stickyLeft : 0,
      }}
    >
      <BreadcrumbStyled separator=">">
        <span className="text-[#939BAF]">當前位置: </span>
        {items.map((item, index) => {
          const isLastItem = index === items.length - 1;
          return (
            <Breadcrumb.Item key={index}>
              {isLastItem || !item.url ? (
                <span className="text-[#1D2029]">{item.label}</span>
              ) : (
                <a
                  href={item.url}
                  target="_blank"
                  className="hover:text-[#1D2029]"
                  style={{ color: "#1D2029" }}
                  rel="noopener noreferrer"
                >
                  {item.label}
                </a>
              )}
            </Breadcrumb.Item>
          );
        })}
      </BreadcrumbStyled>
    </section>
  );
};

export default memo(Crumbs);